import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=03b851e2&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=03b851e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b851e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b851e2')) {
      api.createRecord('03b851e2', component.options)
    } else {
      api.reload('03b851e2', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=03b851e2&scoped=true", function () {
      api.rerender('03b851e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/result/Result.vue"
export default component.exports